import { useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import { Dialog, DialogClose, DialogContent } from "@tenant/ui";
import styles from "./ContactSupportDialog.module.scss";
import { ContactSupportDialogContent } from "./ContactSupportDialogContent";
import { ActionButton } from "@/components/ActionButton";

interface ContactSupportDialogControlledProps {
  open: boolean;
  onClose: () => void;
  showBookingQuestion?: boolean;
}

export const ContactSupportDialogControlled = ({
  open,
  onClose,
  showBookingQuestion = false,
}: ContactSupportDialogControlledProps) => {
  const [, cn] = useModuleBEM(styles, "ContactSupportDialog");
  const { t } = useI18nContext();

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent
        className={cn("dialog")}
        title={t("contactSupport.title")}
        bottomFixedContent={
          <DialogClose>
            <ActionButton message={t("contactSupport.closeButton")} />
          </DialogClose>
        }
      >
        <ContactSupportDialogContent
          showBookingQuestion={showBookingQuestion}
        />
      </DialogContent>
    </Dialog>
  );
};
